import createPalette from 'material-ui/styles/palette';
import createMuiTheme from 'material-ui/styles/theme';
import { lightBlue, green } from 'material-ui/colors';

const theme = createMuiTheme({
  palette: createPalette({
    primary: lightBlue,
    accent: green,
  }),
  fontFamily: 'Comfortaa, Helvetica, Arial, sans-serif'
});

export default theme




// WEBPACK FOOTER //
// ./src/themes/mui.js